import { render } from "./PurchaseUpload.vue?vue&type=template&id=2ef42e8f&scoped=true"
import script from "./PurchaseUpload.vue?vue&type=script&lang=js"
export * from "./PurchaseUpload.vue?vue&type=script&lang=js"

import "./PurchaseUpload.vue?vue&type=style&index=0&id=2ef42e8f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef42e8f"]])

export default __exports__